module.exports = __webpack_public_path__ + "img/tea5.1bfb86e2.png";